export default __webpack_public_path__ + "media/images/pp_logo_name_sm-5f447f466d63a474cb5bebb67e297742.png";